import React from 'react'
import styled from 'styled-components'
import 'assets/font.css'
import { ColorsType, FontsType } from '@astro-ui/fondations'

type SystemIconPropsType = {
  iconName: string
  colorIcon?: keyof ColorsType
  fontSize?: keyof FontsType['fontSizes']
  className?: string
  withCircleBorder?: boolean
  circleBackgroundColor?: keyof ColorsType
}

const SystemIcon = ({
  iconName,
  colorIcon,
  fontSize,
  className,
  withCircleBorder,
  circleBackgroundColor,
}: SystemIconPropsType) => {
  if (withCircleBorder) {
    return (
      <CircleWrapper circleBackgroundColor={circleBackgroundColor} fontSize={fontSize}>
        <Icon
          className={`icon-${iconName} ${className}`}
          colorIcon={colorIcon}
          fontSize={fontSize}
        />
      </CircleWrapper>
    )
  }
  return (
    <Icon className={`icon-${iconName} ${className}`} colorIcon={colorIcon} fontSize={fontSize} />
  )
}

SystemIcon.defaultProps = {
  colorIcon: 'grey',
  fontSize: 'bigger',
  className: '',
  withCircleBorder: false,
  circleBackgroundColor: false,
}

export default React.memo(SystemIcon)

const Icon = styled.i<{
  colorIcon?: keyof ColorsType
  fontSize?: keyof FontsType['fontSizes']
}>`
  &::before {
    color: ${({ theme: { colors }, colorIcon }) => (colorIcon ? colors[colorIcon] : undefined)};
    font-size: ${({ theme: { fontSizes }, fontSize }) =>
      fontSize ? fontSizes[fontSize] : undefined};
  }
`

const CircleWrapper = styled.div<{
  fontSize?: keyof FontsType['fontSizes']
  circleBackgroundColor?: keyof ColorsType
}>`
  display: flex;
  font-size: ${({ theme: { fontSizes }, fontSize }) =>
    fontSize ? fontSizes[fontSize] : undefined};
  padding: ${({ theme: { fontSizes }, fontSize }) => {
    if (!fontSize) return undefined
    const valueSize = +fontSizes[fontSize].split('r')[0]
    return `${valueSize - 0.1}rem`
  }};
  border-radius: 50%;
  background-color: ${({ theme: { colors }, circleBackgroundColor }) =>
    circleBackgroundColor ? colors[circleBackgroundColor] : colors.white};
  height: fit-content;
  width: fit-content;
  i {
    line-height: unset;
  }
`
